import React from 'react';
import { useTranslation } from 'react-i18next';
import EmployeeSelect from './EmployeeSelect.component';
import { SpecificEmployeeSelectProps } from './types';

const RECRUITER_GROUP_KEY = 'recruiter';

const RecruiterSelect = ({
  value,
  onChange,
  isMulti = false,
  isRequired = false,
  menuPlacement = 'auto',
  useMenuPortalTarget = false,
  validationFailureMessage,
  notAssignItem = false
}: SpecificEmployeeSelectProps) => {
  const { t } = useTranslation();

  const translatedRecruiterTitle = t('Recruiter');
  const translatedRecruiterPlaceholder = t('Choose recruiter');
  const label = isRequired
    ? `${translatedRecruiterTitle} *`
    : `${translatedRecruiterTitle}`;

  return (
    <EmployeeSelect
      label={label}
      placeholder={translatedRecruiterPlaceholder}
      value={value}
      onChangeOption={onChange}
      specificGroupFilter={RECRUITER_GROUP_KEY}
      isFilteredByRegionIntersection
      isMulti={isMulti}
      menuPlacement={menuPlacement}
      useMenuPortalTarget={useMenuPortalTarget}
      validationFailureMessage={validationFailureMessage}
      notAssignItem={notAssignItem}
    />
  );
}

export default RecruiterSelect;
